'use client';

import { c as _c } from "react/compiler-runtime";
import { Chip } from '@common/components';
import { cn } from '@core/utils';
import { usePathname, useSearchParams } from 'next/navigation';
import type { ComponentProps } from 'react';
import { PhotoReviewSwiper } from '@/app/donation/_components/PhotoReviewSwiper';
import { GIFT_REVIEW_SORT_TYPE } from '@/app/donation/constants';
import type { GiftReviewSortType } from '@/app/donation/types';
import { TABS } from '../../../../constants';
import { ResponsiveDivider } from '../../../GiftDetailTemplate/ResponsiveDivider';
import { ReviewSummary } from '../../../ReviewSummary';
import { ReviewList } from './_components/ReviewList';
interface GiftTabContentReviewProps {
  reviewRating?: number;
  reviewCount: number;
  reviewList: ComponentProps<typeof ReviewList>['initialList'];
  reviewTotalCount: number;
  photoReviewList: ComponentProps<typeof PhotoReviewSwiper>['photoReviewList'];
  photoReviewCount: number;
  productNumber: string;
}
const REVIEW_SORT = 'reviewSort';
const toReviewSort = (value: string | null): GiftReviewSortType => value === GIFT_REVIEW_SORT_TYPE.RATING_DESC ? GIFT_REVIEW_SORT_TYPE.RATING_DESC : GIFT_REVIEW_SORT_TYPE.LATEST;
export const GiftTabContentReview = t0 => {
  const $ = _c(38);
  const {
    reviewRating,
    reviewCount,
    reviewList,
    reviewTotalCount,
    photoReviewList,
    photoReviewCount,
    productNumber
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  let t1;
  if ($[0] !== searchParams) {
    t1 = toReviewSort(searchParams.get(REVIEW_SORT));
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const reviewSort = t1;
  let t2;
  if ($[2] !== pathname) {
    t2 = nextSort => {
      const nextSearchParams = new URLSearchParams(window.location.search);
      if (nextSort === GIFT_REVIEW_SORT_TYPE.LATEST) {
        nextSearchParams.delete(REVIEW_SORT);
      } else {
        nextSearchParams.set(REVIEW_SORT, nextSort);
      }
      const search = nextSearchParams.toString();
      history.replaceState({
        historyIndex: history.state?.historyIndex
      }, "", `${pathname}${search ? `?${search}` : ""}`);
    };
    $[2] = pathname;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const changeReviewSort = t2;
  let t3;
  if ($[4] !== reviewCount || $[5] !== reviewRating) {
    t3 = <ReviewSummary reviewRating={reviewRating} reviewCount={reviewCount} className="mobile-tablet:mx-16" />;
    $[4] = reviewCount;
    $[5] = reviewRating;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== photoReviewCount || $[8] !== photoReviewList || $[9] !== productNumber) {
    t4 = <PhotoReviewSwiper photoReviewList={photoReviewList} photoReviewCount={photoReviewCount} productNumber={productNumber} className="mobile-tablet:px-20" />;
    $[7] = photoReviewCount;
    $[8] = photoReviewList;
    $[9] = productNumber;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <ResponsiveDivider className="h-0" />;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("flex items-center gap-6 border-b border-Gray-200 px-20 py-12", "mobile-tablet:border-b-0 mobile-tablet:pt-32");
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const t7 = reviewSort === GIFT_REVIEW_SORT_TYPE.LATEST;
  let t8;
  if ($[13] !== changeReviewSort) {
    t8 = () => changeReviewSort(GIFT_REVIEW_SORT_TYPE.LATEST);
    $[13] = changeReviewSort;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t7 || $[16] !== t8) {
    t9 = <Chip theme="primary" className="h-36" type="radio" name="gift-review-sort" value={GIFT_REVIEW_SORT_TYPE.LATEST} checked={t7} onCheckedChange={t8}>최신순</Chip>;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = reviewSort === GIFT_REVIEW_SORT_TYPE.RATING_DESC;
  let t11;
  if ($[18] !== changeReviewSort) {
    t11 = () => changeReviewSort(GIFT_REVIEW_SORT_TYPE.RATING_DESC);
    $[18] = changeReviewSort;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10 || $[21] !== t11) {
    t12 = <Chip theme="primary" className="h-36" type="radio" name="gift-review-sort" value={GIFT_REVIEW_SORT_TYPE.RATING_DESC} checked={t10} onCheckedChange={t11}>평점 높은순</Chip>;
    $[20] = t10;
    $[21] = t11;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== t12 || $[24] !== t9) {
    t13 = <div className={t6}>{t9}{t12}</div>;
    $[23] = t12;
    $[24] = t9;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== productNumber || $[27] !== reviewList || $[28] !== reviewSort || $[29] !== reviewTotalCount) {
    t14 = <ReviewList initialList={reviewList} totalCount={reviewTotalCount} sortType={reviewSort} productNumber={productNumber} />;
    $[26] = productNumber;
    $[27] = reviewList;
    $[28] = reviewSort;
    $[29] = reviewTotalCount;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t13 || $[32] !== t14) {
    t15 = <div className="flex flex-col">{t13}{t14}</div>;
    $[31] = t13;
    $[32] = t14;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15 || $[35] !== t3 || $[36] !== t4) {
    t16 = <section className="flex flex-col pt-32" id={TABS.REVIEW}>{t3}{t4}{t5}{t15}</section>;
    $[34] = t15;
    $[35] = t3;
    $[36] = t4;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  return t16;
};